<template>
    <div class="flex flex-wrap items-center justify-center gap-3 p-2">
        <component
            :is="item.href ? 'a' : 'div'"
            v-for="item in items"
            :key="item.key"
            v-bind="linkAttrs(item)"
            :aria-label="item.title"
            class="relative flex flex-shrink-0 overflow-hidden rounded-lg shadow-lg no-underline"
            :class="[
                isDesktop ? 'h-36 w-72' : 'h-28 w-56',
                { 'grid grid-cols-2': item.title }
            ]"
            @click="onClick"
        >
            <span
                v-if="item.title"
                class="flex items-center bg-stack-emphasis px-3 text-left font-semibold leading-tight text-stack-ink"
                :class="isDesktop ? 'text-base' : 'text-sm'"
            >
                <span class="line-clamp-3">{{ item.title }}</span>
            </span>
            <span class="relative block h-full w-full">
                <img
                    v-if="item.imageUrl"
                    :src="item.imageUrl"
                    :alt="item.imageAlt"
                    class="h-full w-full object-cover"
                />
                <span v-else class="absolute inset-0">
                    <slot name="placeholder" :item="item"></slot>
                </span>
            </span>
        </component>
    </div>
</template>

<script>
export default {
    name: "SliderV2",
    props: {
        items: { type: Array, required: true },
        previewOnly: { type: Boolean, default: false },
        isDesktop: { type: Boolean, default: true }
    },
    methods: {
        linkAttrs(item) {
            return item.href
                ? { href: item.href, target: item.target, rel: item.rel }
                : {};
        },
        onClick(event) {
            if (this.previewOnly) event.preventDefault();
        }
    }
};
</script>
